/**
 * @generated SignedSource<<2b773e9bc0e097e11813b0c983f288f1>>
 * @relayHash 39cfb1709b3e4d15af33b26b3584e8ff
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 39cfb1709b3e4d15af33b26b3584e8ff

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useIcdCodeByDiagnosisCodeQuery$variables = {
  diagnosisCode: string;
  skip: boolean;
};
export type useIcdCodeByDiagnosisCodeQuery$data = {
  readonly icdDiagnosisByDiagnosisCode?: {
    readonly diagnosisCode: string;
    readonly id: string;
    readonly text: string;
    readonly " $fragmentSpreads": FragmentRefs<"IcdDiagnosisFragment">;
  };
};
export type useIcdCodeByDiagnosisCodeQuery = {
  response: useIcdCodeByDiagnosisCodeQuery$data;
  variables: useIcdCodeByDiagnosisCodeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "diagnosisCode"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "diagnosisCode",
    "variableName": "diagnosisCode"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "diagnosisCode",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useIcdCodeByDiagnosisCodeQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*:: as any*/),
            "concreteType": "IcdDiagnosis",
            "kind": "LinkedField",
            "name": "icdDiagnosisByDiagnosisCode",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "IcdDiagnosisFragment"
              }
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useIcdCodeByDiagnosisCodeQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*:: as any*/),
            "concreteType": "IcdDiagnosis",
            "kind": "LinkedField",
            "name": "icdDiagnosisByDiagnosisCode",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isAssociation",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "primaryCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "secondaryCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "associationType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "IcdDiagnosis",
                "kind": "LinkedField",
                "name": "linkedConditionIcdDiagnosis",
                "plural": false,
                "selections": [
                  (v3/*:: as any*/),
                  (v4/*:: as any*/),
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "id": "39cfb1709b3e4d15af33b26b3584e8ff",
    "metadata": {},
    "name": "useIcdCodeByDiagnosisCodeQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "6e048cc783a24af824f58569c46836b2";

export default node;
